import { queryOptions } from '@tanstack/react-query';

import { fetchMatchEvents } from '@apis/events';
import { fetchEuroBracket, fetchLineups, fetchMatch, fetchMatches, getPlayersStatus } from '@apis/matches';
import { Order } from '@shared-types/common.types';
import type { LiveMatch } from '@shared-types/match.types';
import { loadFromAPIs } from '@utilities/fetch';
import { matchApiUrl } from '@utilities/WindowContext';

export const getMatchByIdQuery = (matchId: string) =>
  queryOptions({
    queryKey: ['match', matchId],
    queryFn: ({ signal }) => fetchMatch(matchId, signal),
  });

export const getMatchEventsQuery = (matchId: string, params?: Parameters<typeof fetchMatchEvents>[1]) =>
  queryOptions({
    queryKey: ['match-events', matchId, params],
    queryFn: ({ signal }) => fetchMatchEvents(matchId, { offset: 0, limit: 500, order: Order.DESC, ...params }, signal),
    placeholderData: [],
  });

export const getMatchLineupsQuery = (matchId: string) =>
  queryOptions({
    queryKey: ['match-lineups', matchId],
    queryFn: ({ signal }) => fetchLineups(matchId, signal),
  });

export const getMatchesQuery = (params: Parameters<typeof fetchMatches>[0]) =>
  queryOptions({
    queryKey: ['matches', params],
    queryFn: ({ signal }) => fetchMatches(params, signal),
    placeholderData: [],
  });

export const getLivescoreQuery = (competitionIds: string[]) =>
  queryOptions({
    queryKey: ['livescore', competitionIds],
    queryFn: ({ signal }) =>
      loadFromAPIs<LiveMatch[]>('v5/livescore', { competitionId: competitionIds }, { apiUrl: matchApiUrl, signal }),
    placeholderData: [],
    enabled: !!competitionIds?.length,
  });

export const getMatchPlayersStatusQuery = (matchId: string, status: string | string[]) =>
  queryOptions({
    queryKey: ['players-status', matchId, status],
    queryFn: ({ signal }) => getPlayersStatus(matchId, status, signal),
    placeholderData: [],
  });

export const getEuroBracketQuery = (params: Parameters<typeof fetchEuroBracket>[0]) =>
  queryOptions({
    queryKey: ['bracket', params],
    queryFn: ({ signal }) => fetchEuroBracket(params, signal),
    select: (response) => response?.data,
    placeholderData: { data: [] },
  });
